import __vue_component__ from '../Spinner/Spinner.vue.js';

//
var script = {
  name: 'InfiniteScroll',
  components: {
    Spinner: __vue_component__
  },
  props: {
    tag: {
      type: String,
      default: 'td'
    }
  },

  data() {
    return {
      observer: undefined
    };
  },

  async mounted() {
    this.observer = new IntersectionObserver(([entries]) => {
      if (entries.isIntersecting) {
        this.tableBottomReached();
      }
    });
    this.observe();
  },

  beforeDestroy() {
    this.observer.disconnect();
  },

  methods: {
    observe() {
      if (!this.$refs['infinite-scroll-loader']) {
        return;
      }

      this.observer.disconnect();
      this.observer.observe(this.$refs['infinite-scroll-loader']);
    },

    tableBottomReached() {
      this.$emit('table-bottom-reached', () => {
        this.observe();
      });
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/common/InfiniteScroll.vue_rollup-plugin-vue=script.js